import {
  InMemoryHeader,
  InMemoryString,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function toPascalCase(w) {
  return w[0].toUpperCase() + w.slice(1).toLowerCase();
}

function getHeaders(languages) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
  ]
  for (const lang of languages) {
    headers.push(new InMemoryHeader({
      title: i18n.t(`headers.contract_information.label_{0}`, [lang.language.toUpperCase()]),
      type: new InMemoryString(`Label${toPascalCase(lang.language)}`),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }));
    headers.push(new InMemoryHeader({
      title: i18n.t(`headers.contract_information.value_{0}`, [lang.language.toUpperCase()]),
      type: new InMemoryString(`Value${toPascalCase(lang.language)}`),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }));
  }
  return headers;
}
export default getHeaders;
